/* eslint-disable import/no-anonymous-default-export */
export default {
  GENERATE_OTP: () => "/vendor/auth/generateLoginOtp",
  LOGIN_WITH_OTP: () => "/vendor/auth/loginWithMobileOtp",
};
